import { P2PEngine } from './p2pEngine';
import { HybridFragmentLoader } from './hybrid-fragment-loader';
export class HlsEngine extends P2PEngine {
    constructor(swarmId, settings) {
        super(swarmId, settings);
        this.lastPendingDelay = { http: 0, p2p: 0 };
    }
    createLoaderClass() {
        const engine = this;
        return class LoaderClass extends HybridFragmentLoader {
            constructor(hlsConfig) {
                super(hlsConfig, engine);
            }
        };
    }
    storeSegmentAndDelay(segment, lastPendingDelay) {
        super.storeSegment(segment);
        this.lastPendingDelay = Object.assign(this.lastPendingDelay, lastPendingDelay);
    }
}
HlsEngine.version = __VERSION__;
window.HlsP2PEngine = HlsEngine;
